"use strict";

angular.module("imagetrend.components").directive("hlpFormBuilderFormPdf", [
    "$rootScope",
    "$timeout",
    function($rootScope, $timeout) {
        return {
            restrict: "AE",
            scope: {
                form: "=?",
                refresh: "=?",
                resultSet: "=?",
                classes: "@?",
                count: "=?",
                internal: "@?",
                deficiencies: "=?",
                parameters: "=?",
                deficiencyScore: "=?",
                inspectionChecklist: "=?"
            },
            controller: "HlpFormBuilderFormController",
            replace: true,
            transclude: true,
            templateUrl:
                "templates/form-builder-form/form-builder-form-pdf.html",
            compile: function(elem, attrs) {
                var httpLoading = false;

                var progressListener = $rootScope.$on(
                    "loading:progress",
                    function() {
                        if (!httpLoading) {
                            //console.log('1 form-builder-form-pdf progressListener loading:progress');
                            httpLoading = true;
                        }
                    }
                );

                var finishListener = $rootScope.$on(
                    "loading:finish",
                    function() {
                        elem.ready(function() {
                            var finishListenerTimer = $timeout(function() {
                                //console.log('2 finishListener loading:finish');
                                progressListener();
                                finishListener();
                                $rootScope.$broadcast("pdf:finish");
                                $timeout.cancel(finishListenerTimer);
                            }, 0);
                        });
                    }
                );

                // maybe switch to ng-init
                elem.ready(function() {
                    var timer = $timeout(function() {
                        //if no api calls are made from the form (ie Doing File Upload/Signature and waiting for Document IDs to come back)
                        if (!httpLoading) {
                            //console.log('no api calls');
                            progressListener();
                            finishListener();
                            $rootScope.$broadcast("pdf:finish");
                            $timeout.cancel(timer);
                        }
                    }, 0);
                });

                return {
                    pre: function (scope, iElem, iAttrs) {
                        scope.checkIfImageOrPDF = function (component) {
                            if (component.document_file_name) {
                                var extensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf'];
                                return extensions.includes(component.document_file_name.split('.').pop().toLowerCase());
                            }
                            return false;
                        };
                    },
                    post: function(scope, iElem, iAttrs) {
                        scope.$on("$destroy", function() {
                            //console.log('5 form-builder-form-pdf post progressListener');
                            progressListener(); // apparently this deregisters the listener
                            //console.log('6 form-builder-form-pdf post finishListener');
                            finishListener(); // apparently this deregisters the listener

                            if (iElem) {
                                angular.element(iElem).off();
                                angular.element(iElem).remove();
                                iElem = null;
                            }
                        });
                    }
                };
            }
        };
    }
]);
